// extracted by mini-css-extract-plugin
export default {"select":"exercicioSelect_select__5QVq-","text":"exercicioSelect_text__mzCWA"};